import PropTypes from 'prop-types';
import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import t from '../../../lib/I18n';
import OrderTrip from '../../../records/order/Trip';

import BaseModal from '../../general/BaseModal';
import FareValidity from '../../fares/FareValidity';
import PureRenderComponent from '../../PureRenderComponent';

class RemoveJourneyModal extends PureRenderComponent {

    static propTypes = {
        orderTrip: PropTypes.instanceOf(OrderTrip).isRequired,
        onBack: PropTypes.func.isRequired,
        onConfirm: PropTypes.func.isRequired
    };

    _getFareDetails(fare, key) {
        return (
            <li key={ key } className="order-summary__item order-summary__item--short">
                <Row className="fare-summary">
                    <Col xs={ 12 } md={ 6 } lg={ 6 } className="text-weight--normal no-margin">
                        <p>
                            { fare.getName() }&nbsp;
                            { fare.isGroupSave() && ( t('order.summary.groupSave') ) }
                        </p>
                    </Col>
                </Row>

                <FareValidity
                    from={ fare.outwardJourney.validFrom }
                    to={ fare.outwardJourney.validTo }
                />
            </li>
        );
    }

    render () {

        const { orderTrip, onBack, onConfirm } = this.props;
        const modalProps = {
            titleText: 'order.summary.confirmRemoveJourney',
            closeText: 'button.text.cancel',
            continueText: 'button.text.removeJourney',
            onClose: onBack,
            onContinue: onConfirm,
            className: 'modal--sm modal--remove-journey'
        };

        return (
            <BaseModal { ...modalProps }>
                <Row>
                    <Col sm={ 12 }>
                        <ul className="order-summary__list list-unstyled">
                            { orderTrip.getJourneyFares().map(this._getFareDetails) }
                        </ul>
                    </Col>
                </Row>
            </BaseModal>
        );
    }
}

export default RemoveJourneyModal;
